<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="tnis">The play was produced by the Royal Shakespeare Company, Stratford-upon-Avon, at The Other Place, 2 July 1992, with the following cast:</p>
<table>
<tbody><tr>
<td><p class="tab"><span class="epub-sc">ODYSSEUS</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Ron Cook</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">PENELOPE</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Amanda Harris</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">TELEMACHUS</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Stephen Casey</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">EURYCLEIA</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Claire Benedict</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">EUMAEUS</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Trevor Martin</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">ATHENA</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Susan-Jane Tanner</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">BILLY BLUE</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Rudolph Walker</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">ANTINOUS</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Jonathan Cake</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">NESTOR</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">David Westhead</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">THERSITES</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Gordon Case</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">PROTEUS</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Antony Bunsee</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">NAUSICAA</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Sophie Okonedo</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">CYCLOPS</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Geoffrey Freshwater</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">CIRCE</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Bella Enahoro</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">ANTICLEA</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Darlene Johnson</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-sc">ACHILLES</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Peter de Jersey</p></td>
</tr>
</tbody></table>
<p class="stnis">Other parts played by members of the cast.</p>
<table>
<tbody><tr>
<td><p class="tab"><span class="epub-i">Director</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Gregory Doran</p></td>
</tr>
<tr>
<td><p class="tab"><span class="epub-i">Designer</span></p></td>
<td><p class="tab">   </p></td>
<td><p class="tab">Michael Pavelka</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?33af619c